// src/components/ProductHero/ProductHero.js
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';


const ProductHero = () => {


  return (
    <section className="about-hero-section">
                 <Container>
                   <Row>
                     <Col lg={12}>
                       <div className="about-hero-content">
                         {/* Main Title: About (Regular) Us (Bold) */}
                         <h1 className="about-hero-title">
                           <span>Products</span>
                         </h1>
                       </div>
                     </Col>
                   </Row>
                 </Container>
               </section>
         
  );
};

export default ProductHero;